// import b from "../blob.gif";
import osc from '../Memoji/1.png';
import fsd from '../Memoji/3.png';
import cp from '../Memoji/5.png';
export const servicesData = [
  {
    title: 'Open Source Contributor',
    keyword: 'Contributing to Community',
    imageSrc: osc
  },
  {
    title: 'Full-Stack Developer',
    keyword: 'Awesome Websites',
    imageSrc: fsd
  },
  {
    title: 'Competitive Programmer',
    keyword: 'Problem Solver',
    imageSrc: cp
  }
];
